module.exports = __webpack_public_path__ + "static/icons/icon-add-fd299675e41c92919b161d730271fbb3.svg";